/**
 * Channel filter title component.
 */
import Title from '@components/atoms/text/channelFilterTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';

/**
 * Channel filter title component.
 * Renders the channel filter title with an arrow left icon if the list index is greater than 1.
 */
export default function ChannelFilterTitle() {
  return <Title>{TranslationManager.get('COMPONENTS.FILTER.CHANNELS')}</Title>;
}
